import withAuthHeader from "../../utils/withAuthHeader";
import checkAuthorizationError from "../../utils/checkAuthorizationError";
import {
  mapFetchProductsCategoriesResponse,
  mapEditCategoryRequest,
  mapUpdateCategoriesOrder,
  mapFetchProductResponse,
  mapProductFormToApi,
  mapFetchDetailGroupsResponse,
  mapFetchDetailItemsResponse,
} from "../mappers/products";
import handleRequestError from "../../utils/handleRequestError";

export const fetchProductsCategories =
  (storeId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/cardapios/categorias`;
      const apiResponse = await api.get(url, {
        params: storeId ? { EstabelecimentoId: storeId } : {},
        ...withAuthHeader(),
      });
      const response = mapFetchProductsCategoriesResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const createOrEditCategory =
  ({ category, name, storeId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      try {
        const url = category
          ? `api/v1/cardapios/categorias/${category}`
          : `api/v1/cardapios/categorias`;
        const method = category ? "put" : "post";
        const data = mapEditCategoryRequest({
          name,
          storeId: storeId,
        });
        await api({
          method,
          url,
          data,
          params: {
            EstabelecimentoId: storeId,
          },
          ...withAuthHeader(),
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: e.message,
        };
      }
      return result;
    };

export const deleteCategory =
  ({ category, storeId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      try {
        const url = `api/v1/cardapios/categorias/${category}`;
        const method = "delete";
        await api({
          method,
          url,
          params: storeId ? { EstabelecimentoId: storeId } : {},
          ...withAuthHeader(),
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: e.message,
        };
      }
      return result;
    };

export const updateCategoriesOrder =
  ({ categories, products, storeId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      try {
        const url = `api/v1/cardapios/categorias/ordem`;
        const data = mapUpdateCategoriesOrder({ categories, products, storeId });
        await api({
          method: "put",
          url,
          data,
          params: {},
          ...withAuthHeader(),
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: e.message,
        };
      }
      return result;
    };

export const changeProductStatus =
  ({ productId, storeId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      try {
        const url = `api/v1/cardapios/produtos/${productId}/status`;
        const method = "put";
        const data = { EstabelecimentoId: storeId };
        await api({
          method,
          url,
          data,
          params: {},
          ...withAuthHeader(),
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: e.message,
        };
      }
      return result;
    };

export const changeCategoryStatus =
  ({ categoryId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      try {
        const url = `api/v1/cardapios/categorias/${categoryId}/status`;
        await api.put(url, null, {
          ...withAuthHeader(),
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: e.message,
        };
      }
      return result;
    };

export const deleteProduct =
  ({ productId, storeId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      try {
        const url = `api/v1/cardapios/produtos/${productId}`;
        const method = "delete";
        await api({
          method,
          url,
          ...withAuthHeader(),
          params: storeId ? { EstabelecimentoId: storeId } : {},
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: e.message,
        };
      }
      return result;
    };

export const fetchProduct =
  (productId, storeId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/cardapios/produtos/${productId}`;
      const apiResponse = await api.get(url, {
        ...withAuthHeader(),
        params: storeId ? { EstabelecimentoId: storeId } : {},
      });
      const response = mapFetchProductResponse(apiResponse.data);

      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const updateProduct =
  ({ formData, storeId }) =>
    async (dispatch, getState, api) => {
      let result = {};
      const isNew = !formData.id;
      try {
        const url = isNew
          ? `api/v1/cardapios/produtos`
          : `api/v1/cardapios/produtos/${formData.id}`;
        const data = mapProductFormToApi(formData, storeId);
        await api({
          method: isNew ? "POST" : "PUT",
          url,
          data,
          params: {},
          headers: {
            "Content-Type": "multipart/form-data",
            ...withAuthHeader(false),
          },
        });
        result = {
          success: true,
        };
      } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
          error: handleRequestError(e),
        };
      }
      return result;
    };

export const fetchDetailGroups =
  (storeId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/cardapios/gruposdetalhes`;
      const apiResponse = await api.get(url, {
        ...withAuthHeader(),
        params: storeId ? { EstabelecimentoId: storeId } : {},
      });
      const response = mapFetchDetailGroupsResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const fetchDetailItems =
  (storeId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/cardapios/detalhes`;
      const apiResponse = await api.get(url, {
        ...withAuthHeader(),
        params: storeId ? { EstabelecimentoId: storeId } : {},
      });
      const response = mapFetchDetailItemsResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const postReplicateProduct =
  (data, productId) => async (dispatch, getState, api) => {
    let result = {};
    try {
      const apiData = { EstabelecimentosId: data };
      const url = `api/v1/cardapios/produtos/replicar/${productId}`;
      const apiResponse = await api.post(url, apiData, {
        ...withAuthHeader(),
      });
      const response = apiResponse.data;

      result = {
        success: true,
        data: response,
      };
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const postReplicateMenu = (data) => async (dispatch, getState, api) => {
  let result = {};
  try {
    const apiData = data;
    const url = `api/v1/cardapios/menu/replicar`;
    const apiResponse = await api.post(url, apiData, {
      ...withAuthHeader(),
    });
    const response = apiResponse.data;

    result = {
      success: true,
      data: response,
    };
  } catch (e) {
    checkAuthorizationError(e, dispatch);
    result = {
      error: e.message,
    };
  }
  return result;
};
